angular.module("avant.customer_applications.directives").directive "amountSsnMask", ->
  restrict: 'A'
  require: 'ngModel'
  link: (scope, element, attributes, ngModel) ->

    formatDisplaySsn = (value) ->
      # This is necessary for the mask to work properly if the model value is
      # set before the view value (via autofill or a server-side value)
      return value unless /^\d{9}$/.test(value)
      "#{value.slice(0,3)}-#{value.slice(3,5)}-#{value.slice(5,9)}"

    modelSet = (value) ->
      return unless value
      value

    viewSet = (value) ->
      return unless value
      viewValue = formatDisplaySsn(value)

      if fullMask
        viewValue = viewValue.replace(/\d/g, '*')
      else
        viewValue = viewValue.slice(0,3).replace(/\d/g, '*') +
        viewValue.slice(3,4) +
        viewValue.slice(4,6).replace(/\d/g, '*') +
        viewValue.slice(6, 11)

    fullMask = scope.requirements[attributes.ngModel]?.full_mask

    # The parser needs to be at the end of the $parsers array, and the formatter
    # needs to be at the beginning of the $formatters array; otherwise
    # validations can run on the masked values
    ngModel.$parsers.push(modelSet)
    ngModel.$formatters.unshift(viewSet)

    element.bind "blur", =>
      element.val(viewSet(ngModel.$modelValue))

    element.bind "focus", =>
      return unless ngModel.$modelValue
      element.val(ngModel.$modelValue).trigger('input')
